/* eslint-disable jsx-a11y/no-autofocus */
import React, { useState } from 'react';
import { InputBaseComponentProps } from '@mui/material';
import { utils } from '@rjsf/core';
import { TextField } from '../../stories/TextField';
import { CustomWidgetProps } from '../types';

const { getDisplayLabel } = utils;

const FilledInputWidget = ({
  id,
  placeholder,
  readonly,
  disabled,
  label,
  value,
  onChange,
  onBlur,
  onFocus,
  autofocus,
  options,
  schema,
  uiSchema,
  required,
  formContext: { onHasChanged },
}: CustomWidgetProps): JSX.Element => {
  const [hasChanged, setHasChanged] = useState(false);
  const { emptyValue = required ? undefined : '' } = options;
  const _onChange = ({ target: { value } }: React.ChangeEvent<HTMLInputElement>) => {
    onChange(value === '' ? emptyValue : value);
    setHasChanged(true);
  };
  const _onBlur = ({ target: { value: newVal } }: React.FocusEvent<HTMLInputElement>) => {
    hasChanged && onHasChanged?.({ id, value: newVal });
    onBlur(id, newVal);
    setHasChanged(false);
  };
  const _onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      hasChanged && onHasChanged?.({ id, value });
      setHasChanged(false);
    }
  };

  const _onFocus = ({ target: { value } }: React.FocusEvent<HTMLInputElement>) => onFocus(id, value);

  const displayLabel = getDisplayLabel(
    schema,
    uiSchema,
    /* TODO: , rootSchema */
  );

  let inputType = 'text';
  if (schema.type === 'integer' || schema.type === 'number') {
    inputType = 'number';
  }

  const inputProps: InputBaseComponentProps = {};
  if (schema.type === 'number') inputProps.step = 'any';

  return (
    <>
      <TextField
        label={displayLabel ? label || schema.title : ''}
        id={id}
        data-testid="filled-string-input-widget"
        placeholder={placeholder}
        autoFocus={autofocus}
        disabled={disabled}
        type={inputType}
        value={value || value === 0 ? value : ''}
        onChange={_onChange}
        onBlur={_onBlur}
        onFocus={_onFocus}
        inputProps={inputProps}
        onKeyDown={_onKeyDown}
        fullWidth
        slotProps={{
          htmlInput: {
            readOnly: readonly,
            'aria-label': label || schema.title,
          },
        }}
      />
    </>
  );
};

export default FilledInputWidget;
